/**
 * `localStorage`, with every failure treated as "nothing stored".
 *
 * A private window, cleared or blocked site data, and some preview / thumbnail contexts make
 * `localStorage` throw — on the ACCESSOR itself, before `.getItem` is reached. Where the assistant
 * sits is a convenience: a forgotten position is a nuisance, an assistant that fails to render is not.
 */
export function readStorage(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export function writeStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    // Best effort — see the module note.
  }
}
